// Module 0 — affichage du référentiel d'organisation.
// Les relations sont des identifiants (UUID) : ils ne doivent JAMAIS être affichés à l'écran.
// L'API fournit en lecture un objet site: { id, code, nom } à côté de site_id.

/** "CODE — Nom" (ou l'un des deux), sinon le repli. */
export function libelleSite(site, repli = '–') {
  if (!site) return repli;
  const { code, nom } = site;
  if (code && nom && code.toLowerCase() !== nom.toLowerCase()) return `${code} — ${nom}`;
  return nom || code || repli;
}

/** Site lisible d'un employé (objet site enrichi par l'API) — jamais l'UUID brut. */
export function siteEmploye(employe, repli = '–') {
  return libelleSite(employe && employe.site, repli);
}

/** Libellé d'un site à partir de son identifiant et d'une liste du référentiel. */
export function libelleSiteParId(siteId, sites, repli = '–') {
  if (!siteId) return repli;
  return libelleSite((sites || []).find((s) => s.id === siteId), repli);
}
